var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Brokeree ")]},proxy:true}])}),_c('div',{staticClass:"m-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }